<template>
  <v-snackbar
    :value="pending !== null"
    :timeout="-1"
    bottom
    left
    color="secondary"
  >
    <span v-if="pending">
      <!-- a mapping change is not a removal, so it says what it was -->
      {{ pending.message || $t("removed_item", { name: pending.label }) }}
    </span>

    <template v-slot:action="{ attrs }">
      <span v-if="secondsLeft > 0" class="mr-2 text--disabled">{{ secondsLeft }}</span>
      <v-btn
        text
        color="primary"
        v-bind="attrs"
        @click="$emit('undo')"
      >
        {{ $t("undo") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
/*
 * The bar shown while something can still be taken back.
 *
 * Pairs with the `undoable` mixin for removals: the parent passes its
 * `pendingUndo` and `undoSecondsLeft` in, and handles @undo with
 * `undoPendingRemove`. It also serves changes that have already been made and
 * are reversible - a mapping, say - where the parent passes its own
 * { message } and reverses it in @undo.
 */
export default {
  name: "UndoBar",
  props: {
    pending: {
      type: Object,
      default: null,
    },
    secondsLeft: {
      type: Number,
      default: 0,
    },
  },
};
</script>
